import { render, staticRenderFns } from "./Confirmdentist.vue?vue&type=template&id=fbb863bc&scoped=true&"
import script from "./Confirmdentist.vue?vue&type=script&lang=js&"
export * from "./Confirmdentist.vue?vue&type=script&lang=js&"
import style0 from "./Confirmdentist.vue?vue&type=style&index=0&id=fbb863bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb863bc",
  null
  
)

export default component.exports